import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Direktefakturaer (kind: 'driver-to-orderer' | 'credit-note') for innlogget sjåfør eller bestiller.
// Samme spørring som useInvoices, så eksisterende indeks brukes.
export function useDirectInvoices(role) {
  const { currentUser } = useAuth();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);
  const uid = currentUser?.uid;

  useEffect(() => {
    setInvoices([]);
    if (!uid) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);

    const field = role === 'driver' ? 'driverUid' : 'ordererUid';
    const q = query(
      collection(db, 'invoices'),
      where(field, '==', uid),
      orderBy('createdAt', 'desc')
    );

    return onSnapshot(q, (snap) => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(i => i.kind));
      setLoading(false);
    }, (err) => {
      console.error('useDirectInvoices:', err);
      setInvoices([]);
      setLoading(false);
    });
  }, [uid, role]);

  return { invoices, loading };
}
